//@ts-nocheck
import { UIIndicatorsType } from "./types";

export const ESTIMATE_RESPONSIBLE_INDICATORS: UIIndicatorsType[] = ["change_estimate_state"];
export const PLANCONFIRM_INDICATORS: UIIndicatorsType[] = ["is_planconfirm_approval"];
